/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon16Solid = forwardRef('ArrowAUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.962 7.68a1.25 1.25 0 1 1-1.768-1.767l3.928-3.928a2.656 2.656 0 0 1 3.756 0l3.928 3.928a1.25 1.25 0 0 1-1.768 1.767L9.25 4.892V13.5a1.25 1.25 0 1 1-2.5 0V4.892L3.962 7.68Z" })));
});
